import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';
import { CUSTOMER_TEMPLATE_KEYS } from '../../model/buildObjectTemplateValueKeys';

interface CustomerKeysTabProps {
    onKeySelect?: (key: string) => void;
}

const CustomerKeysTab = ({ onKeySelect }: CustomerKeysTabProps) => {
    const { t } = useTranslation('Objects');

    const rows = useMemo<TemplateKeyRow[]>(
        () =>
            CUSTOMER_TEMPLATE_KEYS.map((name) => ({
                key: wrapTemplateKey(name),
                value: t(`customer.fields.${name}`),
            })),
        [t],
    );

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default CustomerKeysTab;
